export default __webpack_public_path__ + "static/media/thumbnail.e4fe4c5f.png";